import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { NotFound } from '../pages/NotFound'
import { Home } from '../pages/public/Home'
import { Termino } from '../pages/public/Termino'
import { Privacidad } from '../pages/public/Privacidad'
import { Eliminacion } from '../pages/public/Eliminacion'

export const PublicRouter = () => {
    return (
        <>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='privacy' element={<Privacidad />} />
                <Route path='terms' element={<Termino />} />
                <Route path='data-deletion' element={<Eliminacion />} />
                <Route path='oops' element={<NotFound />} />
                <Route path='*' element={<Navigate to='/oops' />} />
            </Routes>
        </>
    )
}
